import React, { useState } from "react";
import logo from "../assets/E_Logo_Black.svg";
import arrowIcon from "../assets/arrow.svg";
import ContactUsModal from "./ContactUsModal";

type InterviewHeaderProps = {
  onContactClick?: () => void;
};

const InterviewHeader: React.FC<InterviewHeaderProps> = ({ onContactClick }) => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const handleContactUsClick = () => {
    if (onContactClick) {
      onContactClick();
    } else {
      setIsContactModalOpen(true);
    }
  };

  const handleCloseContactModal = () => {
    setIsContactModalOpen(false);
  };

  return (
    <>
      <div className="w-full h-[76px] bg-white fixed top-0 left-0 right-0 z-50 border-b border-[#F0F0F0]">
        <div className="flex flex-row items-center justify-between h-full py-[24px] w-[70%] mx-auto">
          <div className="flex flex-row items-center gap-2 text-[#001630] font-ubuntu text-[20px] font-medium leading-[30px]">
            <img src={logo} alt="logo" className="w-[29px] h-[28px]" />
            <span>
              Employ<span className="text-[#1FD18A]">Ability.AI</span>
            </span>
          </div>
          <div className="flex flex-row items-center gap-2">
            <p className="text-[#8F9091] text-[14px] font-normal font-ubuntu leading-[21px] lowercase">
              facing a problem?
            </p>
            <button
              onClick={handleContactUsClick}
              className="text-[#001630] text-center font-ubuntu text-[14px] font-medium leading-[21px] uppercase hover:opacity-80 transition-opacity cursor-pointer"
              type="button"
            >
              CONTACT US
            </button>
          </div>
        </div>
      </div>

      <ContactUsModal 
        isOpen={isContactModalOpen} 
        onClose={handleCloseContactModal} 
      />
    </>
  );
};

export const ExitInterviewButton: React.FC<{ onExit?: () => void; title?: string }> = ({
  onExit,
  title = "Interview",
}) => {
  return (
    <div
      className="flex flex-row items-center gap-2 cursor-pointer hover:opacity-80 my-8 xl:my-5"
      onClick={onExit}
      role="button"
      tabIndex={0}
    >
      <div className="bg-white rounded-full p-2 border border-[#0000001A] w-[30px] h-[30px] flex items-center justify-center">
        <img src={arrowIcon} alt="back" />
      </div>
      <p className="text-body2 text-grey-9">Exit {title}</p>
    </div>
  );
};

export default InterviewHeader;
